import React from "react";
import "./SplashScreen.css";
import {greeting} from "../../portfolio";

export default function SplashScreen({ isExiting }) {
  const cls = isExiting ? "splash-container sp-exiting" : "splash-container";

  return (
    <div className={cls}>
      {/* Star layers */}
      <div className="sp-stars sp-stars-1" />
      <div className="sp-stars sp-stars-2" />
      <div className="sp-stars sp-stars-3" />

      {/* Nebula blobs */}
      <div className="sp-nebula sp-nebula-a" />
      <div className="sp-nebula sp-nebula-b" />
      <div className="sp-nebula sp-nebula-c" />

      {/* Sci-fi HUD overlay */}
      <div className="sp-hud">
        <div className="sp-corner sp-corner--tl" />
        <div className="sp-corner sp-corner--tr" />
        <div className="sp-corner sp-corner--bl" />
        <div className="sp-corner sp-corner--br" />
        <div className="sp-scanline" />
      </div>

      {/* Planet system */}
      <div className="sp-system">
        {/* Shockwave rings (hidden until explosion) */}
        <div className="sp-shockwave sp-shockwave-1" />
        <div className="sp-shockwave sp-shockwave-2" />
        <div className="sp-shockwave sp-shockwave-3" />

        {/* Organic orbit rings */}
        <div className="sp-ring sp-ring-1" />
        <div className="sp-ring sp-ring-2" />
        <div className="sp-ring sp-ring-3" />

        {/* Moon orbits */}
        <div className="sp-moon-orbit sp-moon-orbit-1">
          <div className="sp-moon sp-moon-1" />
        </div>
        <div className="sp-moon-orbit sp-moon-orbit-2">
          <div className="sp-moon sp-moon-2" />
        </div>

        {/* Purple ice planet */}
        <div className="sp-planet">
          <div className="sp-band sp-band-1" />
          <div className="sp-band sp-band-2" />
          <div className="sp-band sp-band-3" />
          <div className="sp-band sp-band-4" />
          <div className="sp-storm" />
          <div className="sp-shine" />
          <div className="sp-atmo" />
        </div>
      </div>

      {/* Full-screen flash overlay (used during explosion) */}
      <div className="sp-flash" />

      {/* Name + tag */}
      <div className="sp-title-wrap">
        <span className="sp-bracket">&lt;</span>
        <span className="sp-name">{greeting.username}</span>
        <span className="sp-bracket"> /&gt;</span>
      </div>

      {/* Tagline */}
      <p className="sp-tagline">Engineer · Freelancer · Tech Enthusiast</p>

      {/* Loading bar */}
      <div className="sp-bar-wrap">
        <div className="sp-bar" />
      </div>
    </div>
  );
}
